import React from "react";
import { Box, Grid, IconButton, Tooltip } from "@material-ui/core";
import firebase from "firebase/compat";
import axios from "axios";
import "devextreme/dist/css/dx.light.css";
import Swal from "sweetalert2";

import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  Export,
  Lookup,
  Editing,
  Item,
  Popup,
  Form,
  Selection,
  SearchPanel,
} from "devextreme-react/data-grid";
import Card from "components/Card/Card";
import { SelectBox } from "devextreme-react";

const allowedPageSizes = [5, 10, "Todos"];

const texts = {
  exportAll: "Exportar todos los datos",
  exportSelectedRows: "Exportar filas seleccionadas",
  exportTo: "Exportar",
};

const texts2 = {
  confirmDeleteMessage: "Estas seguro de eliminar la empresa?",
  cancelRowChanges: "Cancelar",
  saveRowChanges: "Guardar",
};

class MonitorServicio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      listaEmpresas: [],
      usuarioEmpresa: "",
      usuarioRol: "",
    };

    const db = firebase.firestore();
    db.collection("APIEmpresas").onSnapshot(
      (snapshot) => {
        const _data = snapshot.docs.map((doc) => doc.data());
        let usuario = JSON.parse(localStorage.getItem("usuario"));
        this.setState({
          listaEmpresas: _data,
          usuarioEmpresa: usuario.empresa,
          usuarioRol: usuario.rol,
        });

        if (this.state.usuarioEmpresa === null) {
          axios
            .get(
              "https://log.yubapps.com/api/YUBASyncAPI?nombre_coleccion=yubasync_ejecucion_log&yuba_token=ALL&yuba_key=ALL"
            )
            .then((res) => {
              this.setState({ data: res.data });
            });
        } else {
          let empresa = this.state.listaEmpresas.filter(
            (empresa) => empresa.nombre === this.state.usuarioEmpresa
          );
          let key = empresa[0].token;
          let token = empresa[0].access_key;
          axios
            .get(
              `https://log.yubapps.com/api/YUBASyncAPI?nombre_coleccion=yubasync_ejecucion_log&yuba_token=${token}&yuba_key=${key}`
            )
            .then((res) => {
              this.setState({ data: res.data });
            });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
  render() {
    return (
      <div>
        <Grid>
          <Card
            style={{
              padding: 10,
              width: "100%",
            }}
          >
            <Box width="100%">
              <h4
                style={{
                  fontWeight: 500,
                  position: "relative",
                }}
              >
                MONITOR SERVICIO
              </h4>
              <div
                style={{
                  position: "absolute",
                  zIndex: 100,
                  right: 70,
                }}
              ></div>
              <DataGrid
                dataSource={this.state.data}
                keyExpr="_id"
                showColumnLines={true}
                onRowClick={() => {}}
                onInitNewRow={() => {}}
                onExporting={(e) => {}}
                showHeaderFilter={true}
                showRowLines={true}
                columnAutoWidth={true}
                showBorders={true}
                onCellPrepared={() => {}}
                onRowRemoved={() => {}}
                onRowInserted={() => {}}
                onInitialized={() => {}}
                onRowUpdated={() => {}}
                rowAlternationEnabled={true}
              >
                <Editing
                  mode="popup"
                  allowUpdating={false}
                  allowAdding={false}
                  allowDeleting={false}
                  useIcons={true}
                  texts={texts2}
                >
                  <Popup
                    title="Monitor Servicio"
                    showTitle={true}
                    width={700}
                    height={400}
                  />
                  <Form>
                    <Item itemType="group" colCount={2} colSpan={2}>
                      <Item dataField="nombre_empresa" caption="Empresa" />
                      <Item dataField="nombre_proveedor" caption="Marketplace" />
                      <Item dataField="fecha_date" caption="Fecha" />                 
                      <Item dataField="servicio" caption="Servicios" />
                    </Item>
                  </Form>
                </Editing>
                <HeaderFilter visible={true} />
                <Column dataField="nombre_empresa" caption="Empresa" />
                <Column dataField="nombre_proveedor" caption="Marketplace" />
                <Column dataField="fecha_date" caption="Fecha" />
                <Column dataField="servicio" caption="Servicios" />
                <Paging defaultPageSize={10} />
                <Pager
                  visible={true}
                  allowedPageSizes={allowedPageSizes}
                  displayMode="full"
                  showPageSizeSelector={true}
                  showInfo={true}
                  showNavigationButtons={true}
                />
                <Export
                  enabled={true}
                  allowExportSelectedData={true}
                  texts={texts}
                />
              </DataGrid>
            </Box>
          </Card>
        </Grid>
      </div>
    );
  }
}

export default MonitorServicio;
